import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { InfoTooltip, NumberInput } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import {
   MedicalDeviceOrderFormRegister,
   MedicalDeviceOrderFormWatch,
   MedicalDeviceOrderRefundLimitMultiplicityFormBeanPart,
} from '../medicalDeviceOrder.types';
import { isMedicalDeviceFieldRequired } from '../medicalDeviceOrder.utils';

type RefundLimitMultiplicityFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister<MedicalDeviceOrderRefundLimitMultiplicityFormBeanPart>;
   readonly watch: MedicalDeviceOrderFormWatch<MedicalDeviceOrderRefundLimitMultiplicityFormBeanPart>;
};

const StyledRefundLimitMultiplicityField = styled.div`
   position: relative;
`;
StyledRefundLimitMultiplicityField.displayName = 'StyledRefundLimitMultiplicityField';

const StyledRefundLimitMultiplicityTooltipTrigger = styled.div`
   position: absolute;
   right: -30px;
   bottom: 10px;
`;
StyledRefundLimitMultiplicityTooltipTrigger.displayName = 'StyledRefundLimitMultiplicityTooltipTrigger';

const RefundLimitMultiplicityTooltip = (): JSX.Element => {
   return (
      <StyledRefundLimitMultiplicityTooltipTrigger>
         <InfoTooltip
            testId={'refundLimitMultiplicityInfo'}
            content={<Translate>{medicalDevicesTranslationKeys.fields.refundLimitMultiplicityInfo}</Translate>}
         />
      </StyledRefundLimitMultiplicityTooltipTrigger>
   );
};

const REFUND_LIMIT_MULTIPLICITY_STEP = 1;
const REFUND_LIMIT_MULTIPLICITY_PRECISION = 1;
const REFUND_LIMIT_MULTIPLICITY_MIN = 1;
const REFUND_LIMIT_MULTIPLICITY_DEFAULT = 1;

export const RefundLimitMultiplicityField = (props: RefundLimitMultiplicityFieldProps): JSX.Element => {
   const controller = props.register('refundLimitMultiplicity', {
      required: isMedicalDeviceFieldRequired(props.watch, 'refundLimitMultiplicity'),
   });
   return (
      <StyledRefundLimitMultiplicityField>
         <NumberInput
            testId={'refundLimitMultiplicity'}
            label={medicalDevicesTranslationKeys.fields.refundLimitMultiplicity}
            controller={controller}
            defaultValue={REFUND_LIMIT_MULTIPLICITY_DEFAULT}
            stepValue={REFUND_LIMIT_MULTIPLICITY_STEP}
            precision={REFUND_LIMIT_MULTIPLICITY_PRECISION}
            min={REFUND_LIMIT_MULTIPLICITY_MIN}
            disabled
         />
         <RefundLimitMultiplicityTooltip />
      </StyledRefundLimitMultiplicityField>
   );
};
